export default __webpack_public_path__ + "img/header-bcb2ce26.png";